module.exports = __webpack_public_path__ + "static/media/sensable_31.e84f59c5.gif";